import { Grid, Stack, useMediaQuery } from "@mui/material";
import { useMemo, useState } from "react";
import PageContainer from "src/components/container/PageContainer";

// components
import { IconChevronLeft } from "@tabler/icons";
import { axiosInstance } from "src/api/axios";
import TotalBalance from "./components/MonthlyEarnings";
import RecentTransactions from "./components/RecentTransactions";
import TotalEarnings from "./components/TotalEarnings";

function Transactions() {
  const [user, setUser] = useState({});
  const [wallet, setWallet] = useState({});
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  useMemo(() => {
    axiosInstance.get("/users").then((response) => {
      if ("status" in response && response.status === 200) {
        setUser(response.data);
        if (response.data?.wallet) {
          axiosInstance
            .get(
              `/users/wallet/${
                response.data.wallet?.id || response.data.wallet
              }`
            )
            .then((wallet) => {
              if (wallet?.status === 200) {
                setWallet(wallet.data);
              }
            });
        }
      }
    });
  }, []);

  return (
    <PageContainer
      title="Transactions | EarnPati"
      description="this is Earnpati Transactions page"
      sx={{ maxWidth: { xs: "100vw", lg: "70vw" } }}
    >
      <Stack
        direction={"row"}
        justifyContent="start"
        sx={{
          height: "70px",
          padding: "10px 15px",
        }}
      >
        <IconChevronLeft
          onClick={() => {
            window.location.href = "/dashboard";
          }}
        />
      </Stack>
      <Grid container spacing={1} sx={{ padding: "0 .5rem" }}>
        <Grid container spacing={lgUp ? 1 : 2.5}>
          <Grid item xs={6} lg={6}>
            <TotalEarnings wallet={wallet} user={user} />
          </Grid>

          <Grid item xs={6} lg={6}>
            <TotalBalance wallet={wallet} user={user} />
          </Grid>
        </Grid>
        <Grid item xs={12} my={2}>
          <RecentTransactions transactions={wallet?.transactions} />
        </Grid>
      </Grid>
    </PageContainer>
  );
}

export default Transactions;
